module.exports = __webpack_public_path__ + "static/media/icon-event__revolucion-industrial-hover.4da4d7e6.svg";